export default class InfinityScrollOperation {
    /**
     * @param { InfinityScroll } infinityScroll
     */
    constructor(infinityScroll) {
        this.infinityScroll = infinityScroll

        this.url = infinityScroll.api.url
        this.method = 'GET'
    }

    params() {
        this.infinityScroll.api.pageNumber += 1

        return this.infinityScroll.prepareDataApi()
    }

    resolve(response) {
        this.infinityScroll.runOnceLoaded(() => {
            let { result } = response

            this.infinityScroll.resolveResponse({
                data: result.data || [],
                currentPage: result.meta.current_page,
                lastPage: result.meta.last_page,
                total: result.meta.total,
            })

            this.infinityScroll.loadUntilScroll(true)
        })
    }

    reject(error) {
        this.infinityScroll._lastAjaxStatus.error = error
    }

    clean() {
        this.infinityScroll.runOnceLoaded(() => {
            this.infinityScroll.resetStatus()

            this.infinityScroll.element.innerHTML = ''
        })
    }

    started() {
        this.infinityScroll.startLoading()
    }

    done() {
        this.infinityScroll.stopLoading()
    }
}
